var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseElForm',_vm._b({},'BaseElForm',_vm.$attrs,false),_vm._l((_vm.displayData),function(info){return _c('BaseElFormItem',{key:info.label,attrs:{"label":info.label}},[_c('p',[_vm._v(_vm._s(info.value))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }